var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_153_4106)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 17.6H17.6C15.602 17.6 14.018 19.202 14.018 21.2L14 42.8C14 44.798 15.602 46.4 17.6 46.4H46.4C48.398 46.4 50 44.798 50 42.8V21.2C50 19.202 48.398 17.6 46.4 17.6ZM46.4 42.8H17.6V32H46.4V42.8ZM46.4 24.8H17.6V21.2H46.4V24.8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_153_4106",
    x1: 0,
    y1: 0,
    x2: 64,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93F090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60BFB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSubscription);
export default __webpack_public_path__ + "static/media/settings_subscription.206e805cf3c0c02031b788ab31d7d729.svg";
export { ForwardRef as ReactComponent };